<template>
    <div
        :class="{
            'l-header-main__search': true,
            'is-form-visible': isFormVisible,
            'is-open': isOpen,
        }"
    >
        <div class="c-search">
            <AutocompleteForm
                :autocompleteUrl="autocompleteUrl"
                :isFormVisible="isFormVisible"
                :isOpen="isOpen"
                :inputPlaceholder="inputPlaceholder"
                v-model="keyword"
                @show-form="showForm"
                @hide-form="hideForm"
                @searched="setMatches"
            />

            <AutocompleteResults
                v-if="isOpen"
                :matches="matches"
                :keyword="keyword"
                :totals="totals"
            />
        </div>
    </div>
</template>

<script>
import { checkResolution } from "../../functions/helpers";
import RshopAutocomplete from "./../../../../vendor/rshop/frontend/assets/js/components/Autocomplete";
import { showOverlay, hideOverlay } from "./../../functions/overlay";

export default {
    extends: RshopAutocomplete,
    components: {
        AutocompleteForm: () => import("./AutocompleteForm"),
        AutocompleteResults: () => import("./AutocompleteResults"),
    },
    created() {
        if (typeof Event.on === "function") {
            Event.on("Autocomplete.showForm", (response) => {
                if (this.isFormVisible) {
                    this.hideForm();
                } else {
                    this.showForm();
                }
            });
        }
    },
    data() {
        return {
            isFormVisible: false,
        };
    },
    computed: {
        inputPlaceholder() {
            return checkResolution("cxs")
                ? this.$t("Autocomplete.Header.placeholderMobile")
                : this.$t("Autocomplete.Header.placeholder");
        },
    },
    methods: {
        showForm() {
            this.isFormVisible = true;

            if (this.matches.count) {
                this.isOpen = true;
            }
        },
        hideForm() {
            this.isFormVisible = false;
        },
        handleClickOutside($event) {
            if (
                !this.$el.contains($event.target) &&
                (this.isOpen || this.isFormVisible) &&
                !$event.target.parentNode.classList.contains("js-trigger-search")
            ) {
                this.isOpen = false;
                this.isFormVisible = false;
                this.selectedIndex = -1;

                this.$el.dispatchEvent(new CustomEvent("autocompleteHide"));

                if (typeof window.Event.dispatch === "function") {
                    window.Event.dispatch("Autocomplete.hide");
                }
            }
        },
    },
    watch: {
        isFormVisible(value) {
            if (value) {
                showOverlay("autocomplete");
            } else {
                hideOverlay("autocomplete");
            }
        },
    },
};
</script>
